import {parsePhoneNumber} from 'libphonenumber-js';

export const formatPhoneNumber = (phone: string) => {
  const cleaned = `${phone}`.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phone;
};

export const ensurePlus = (phone: string) => (!phone || phone.includes('+') ? phone : `+${phone}`);

export const formatPhone = (rawPhone: string) => {
  if (!rawPhone) {
    return '';
  }

  try {
    const phone = parsePhoneNumber(rawPhone);

    if (phone.country === 'US') {
      return `+1 ${phone.formatNational()}`;
    }

    return phone.formatInternational();
  } catch (err) {
    return rawPhone;
  }
};
